/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  MeResponseDto,
  UpdateRolePayloadDto,
  UserOnboardingPayloadDto,
  UserPaginationResponseDto,
  UserResponseDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    MeResponseDtoFromJSON,
    MeResponseDtoToJSON,
    UpdateRolePayloadDtoFromJSON,
    UpdateRolePayloadDtoToJSON,
    UserOnboardingPayloadDtoFromJSON,
    UserOnboardingPayloadDtoToJSON,
    UserPaginationResponseDtoFromJSON,
    UserPaginationResponseDtoToJSON,
    UserResponseDtoFromJSON,
    UserResponseDtoToJSON,
} from '../models/index';

export interface FilterUsersRequest {
    searchText?: string;
    isNamedUnderwriter?: boolean;
    page?: number;
    pageSize?: number;
}

export interface GetUserByIdRequest {
    userId: string;
}

export interface UpdateUserRoleRequest {
    userId: string;
    updateRolePayloadDto: UpdateRolePayloadDto;
}

export interface UserOnboardingRequest {
    userOnboardingPayloadDto: UserOnboardingPayloadDto;
}

/**
 * 
 */
export class UserApi extends runtime.BaseAPI {

    /**
     * Filter users
     */
    async filterUsersRaw(requestParameters: FilterUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserPaginationResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['searchText'] != null) {
            queryParameters['searchText'] = requestParameters['searchText'];
        }

        if (requestParameters['isNamedUnderwriter'] != null) {
            queryParameters['isNamedUnderwriter'] = requestParameters['isNamedUnderwriter'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/filter`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Filter users
     */
    async filterUsers(requestParameters: FilterUsersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserPaginationResponseDto> {
        const response = await this.filterUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get me
     */
    async getMeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MeResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MeResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get me
     */
    async getMe(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MeResponseDto> {
        const response = await this.getMeRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get user by id
     */
    async getUserByIdRaw(requestParameters: GetUserByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MeResponseDto>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getUserById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MeResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get user by id
     */
    async getUserById(requestParameters: GetUserByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MeResponseDto> {
        const response = await this.getUserByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update user role
     */
    async updateUserRoleRaw(requestParameters: UpdateUserRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling updateUserRole().'
            );
        }

        if (requestParameters['updateRolePayloadDto'] == null) {
            throw new runtime.RequiredError(
                'updateRolePayloadDto',
                'Required parameter "updateRolePayloadDto" was null or undefined when calling updateUserRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/user/{userId}/update-role`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateRolePayloadDtoToJSON(requestParameters['updateRolePayloadDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update user role
     */
    async updateUserRole(requestParameters: UpdateUserRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUserRoleRaw(requestParameters, initOverrides);
    }

    /**
     * User onboarding
     */
    async userOnboardingRaw(requestParameters: UserOnboardingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserResponseDto>> {
        if (requestParameters['userOnboardingPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'userOnboardingPayloadDto',
                'Required parameter "userOnboardingPayloadDto" was null or undefined when calling userOnboarding().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/user/onboard`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserOnboardingPayloadDtoToJSON(requestParameters['userOnboardingPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserResponseDtoFromJSON(jsonValue));
    }

    /**
     * User onboarding
     */
    async userOnboarding(requestParameters: UserOnboardingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserResponseDto> {
        const response = await this.userOnboardingRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
